import React from 'react';
import { EditDishState } from './editDishState/EditDishState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const EditDishPageV2: React.FC = () => {
	return (
		<EditDishState>
			<Forms />
			<ModalWindows />
		</EditDishState>
	);
};
